// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
// Describes the navigation hierarchy of the billing section. Drives the
// hover dropdown attached to the "Billing" crumb in the billing breadcrumb
// trail so the trail doubles as a quick-jump nav within the section.
import {
  BreadcrumbNavSection,
  SectionBreadcrumbItem,
} from '@/components/section-breadcrumbs';

// Sections that live beneath the billing hub at /billing. The dropdown
// renders a `Pages` header above the day-to-day operational surfaces and a
// `Reports` header above the analytical surfaces so users can scan the menu
// by intent.
const BILLING_NAV_SECTIONS: BreadcrumbNavSection[] = [
  {
    heading: 'Pages',
    items: [
      { label: 'Billing plans', to: '/billing/plans' },
      { label: 'Charges', to: '/billing/charges' },
      { label: 'Invoices', to: '/billing/invoices' },
    ],
  },
  {
    heading: 'Reports',
    items: [
      { label: 'A/R aging', to: '/billing/aging' },
      { label: 'Billing lifecycle', to: '/billing/lifecycle' },
      { label: 'Invoice line items', to: '/billing/invoice-line-items' },
    ],
  },
];

// Shared root crumb for billing breadcrumb trails. Every billing page leads
// with this crumb so the section dropdown is attached consistently without
// each page re-declaring the label, route, and sections.
export const BILLING_BREADCRUMB_ROOT: SectionBreadcrumbItem = {
  label: 'Billing',
  to: '/billing',
  sections: BILLING_NAV_SECTIONS,
};
